import { useEffect } from 'react';

declare global {
  interface Window {
    TrelloPowerUp: any;
    ga: any;
  }
}

function getAccentColor(t: any) {
  const context = t.getContext();

  const theme = context.theme ?? context.initialTheme ?? 'light';

  if (theme === 'light') {
    return '#FFFFFF';
  }

  return '#1D2125';
}

const initialize = () => {
  window.TrelloPowerUp.initialize(
    {
      'board-buttons': async (t: any) => {
        return [
          {
            icon: './archive.svg',
            text: 'Archive',
            callback: function (x: any) {
              t.modal({
                url: './modal',
                accentColor: getAccentColor(x),
                fullscreen: true,
              });
            },
          },
        ];
      },
    },
    {
      appKey: '33c0c8cc351e11ca11c38efc8f48e1ce',
      appName: 'Archive Manager',
      localization: {
        defaultLocale: 'en',
        supportedLocales: ['en'],
        resourceUrl: './strings/{locale}.json',
      },
    }
  );
};

export const IframeConnector = () => {
  useEffect(() => {
    initialize();
  }, []);

  return <div>ok</div>;
};
